module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pick_list":"Pick list","generated":"Generated","orders":"Orders","variant":"Variant"},"id":{"pick_list":"Daftar pesanan","generated":"Terhasil","orders":"Order","variant":"Varian"}}')
  delete Component.options._Ctor
}
